export default __webpack_public_path__ + "static/media/ThaiHealth-bk.d9c8579b.jpeg";